import React from 'react';
import ReserveFieldOrganizer from '@/components/reserve/ReserveFieldOrganizer/ReserveFieldOrganizer';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormOrganizer: React.FC = () => {
  const { form, organizer, users } = useReserveForm();
  return (
    <ReserveFieldOrganizer
      form={form}
      defaultValue={(organizer ?? users) ? { value: users[0] } : undefined}
      errors={form.formState.errors}
    />
  );
};
